const React = require('react')
const { useState } = require('react')
const { useHistory } = require('react-router-dom')
const { Card, CardHeader, CardBody, Collapse } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/verifyContract/index.css')

const Success = props => {
    const { data } = props
    const history = useHistory()
    const { network } = useNetworkConfig()
    const params = new URLSearchParams(location.search)

    const [isSuccessOpen, setIsSuccessOpen] = useState(true)
    const [isCompilerLogOpen, setIsCompilerLogOpen] = useState(true)

    return (
        <Card className='box table-section' style={{ padding: '0px', border: 'none' }}>
            <CardHeader
                className='verify-card-header cursor-pointer'
                onClick={() => setIsSuccessOpen(!isSuccessOpen)}
                style={{
                    border: !isSuccessOpen && 'none',
                    borderColor: isSuccessOpen && 'var(--dropdown-background)'
                }}
            >
                <div>
                    <div style={{ fontWeight: 'bold' }}>
                        <span>Compiler Output</span>
                    </div>
                </div>
                <i className={`fas fa-angle-${isSuccessOpen ? 'up' : 'down'}`} />
            </CardHeader>
            <Collapse isOpen={isSuccessOpen}>
                <CardBody>
                    <Card
                        className='box table-section'
                        style={{ padding: '0px', border: '1px solid var(--dropdown-background)' }}
                    >
                        <CardHeader
                            className='verify-card-header cursor-pointer'
                            onClick={() => setIsCompilerLogOpen(!isCompilerLogOpen)}
                            style={{
                                border: !isCompilerLogOpen && 'none',
                                borderColor: isCompilerLogOpen && 'var(--dropdown-background)'
                            }}
                        >
                            <div>
                                <div style={{ fontWeight: 'bold' }}>
                                    <span>Compiler Debug Log</span>
                                </div>
                            </div>
                            <i className={`fas fa-angle-${isCompilerLogOpen ? 'up' : 'down'}`} />
                        </CardHeader>
                        <Collapse isOpen={isCompilerLogOpen}>
                            <CardBody>
                                • Note: Contract was created during TxHash:&nbsp;
                                <span
                                    className={`${network.name}-text-color cursor-pointer`}
                                    onClick={() =>
                                        history.push(
                                            `/${network.name}/tx/${data?.information.createTransactionHash.hash}`
                                        )
                                    }
                                >
                                    {data?.information.createTransactionHash.hash}
                                </span>
                            </CardBody>
                        </Collapse>
                    </Card>
                    <div
                        style={{
                            backgroundColor: 'var(--dropdown-background)',
                            borderRadius: '8px',
                            padding: '16px',
                            margin: '16px 0'
                        }}
                    >
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{ fontWeight: 'bold' }}>Compiler Version:</span>
                            &nbsp;{data?.information.contract.compilerVersion}
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{ fontWeight: 'bold' }}>Optimization Enabled:</span>
                            &nbsp;{data?.information.contract.optimizationUsed ? 'Yes' : 'No'}
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{ fontWeight: 'bold' }}>Runs:</span>
                            &nbsp;
                            {data?.information.contract.optimizationUsed ? data?.information.contract.runs : 0}
                        </div>
                    </div>
                    <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                        Constructor Arguments Used (ABI-encoded)
                    </div>
                    <div
                        style={{
                            backgroundColor: 'var(--dropdown-background)',
                            borderRadius: '8px',
                            padding: '16px',
                            margin: '16px 0',
                            maxHeight: '200px',
                            overflowY: 'auto'
                        }}
                    >
                        {data?.information.contract.constructor}
                    </div>
                    <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Contract Name</div>
                    <div
                        style={{
                            backgroundColor: 'var(--dropdown-background)',
                            borderRadius: '8px',
                            padding: '16px',
                            margin: '16px 0',
                            maxHeight: '200px',
                            overflowY: 'auto'
                        }}
                    >
                        {data?.information.contract.name}
                    </div>
                    <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Contract Bytecode</div>
                    <div
                        style={{
                            backgroundColor: 'var(--dropdown-background)',
                            borderRadius: '8px',
                            padding: '16px',
                            margin: '16px 0',
                            maxHeight: '200px',
                            overflowY: 'auto',
                            fontFamily: 'monospace'
                        }}
                    >
                        {data?.information.bytecode}
                    </div>
                    <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Contract ABI</div>
                    <div
                        style={{
                            backgroundColor: 'var(--dropdown-background)',
                            borderRadius: '8px',
                            padding: '16px',
                            margin: '16px 0',
                            maxHeight: '200px',
                            overflowY: 'auto',
                            fontFamily: 'monospace'
                        }}
                    >
                        {data?.information.contract.abi && JSON.stringify(data?.information.contract.abi)}
                    </div>
                </CardBody>
            </Collapse>
        </Card>
    )
}

module.exports = { Success }
